import React, { useContext, useEffect, useState } from 'react';
import { useReducer } from 'reinspect';
import combinedReducer from './reducers';
import storage from './storage';

const StoreContext = React.createContext();

export const SESSION_STATE_KEY = 'app.context.store.ef37bc9f1';

export const StoreProvider = ({ children }) => {
    const [isInitialized, setIsInitialized] = useState(false);

    // Init all states
    const [memorizedState, setMemorizedState] = useState(null);

    // Load state from storage on mount
    useEffect(() => {
        const loadState = async () => {
            try {
                const storedState = await storage.getItem(SESSION_STATE_KEY);
                setMemorizedState(storedState);
            } catch (error) {
                console.error('Failed to load state from storage:', error);
                setMemorizedState(null);
            } finally {
                setIsInitialized(true);
            }
        };
        loadState();
    }, []);

    const initialState = memorizedState || combinedReducer(undefined, { type: '@@INIT' });
    // 
    const contextValue = useReducer(combinedReducer, initialState);

    useEffect(() => {
        if (!isInitialized) return; // Don't save until initial load is complete

        // Save to storage (async, non-blocking)
        storage.setItem(SESSION_STATE_KEY, contextValue[0]).catch(error => {
            console.error('Failed to save state to storage:', error);
        });
    }, [contextValue, isInitialized]);

    // Don't render until state is loaded
    if (!isInitialized) {
        return <div>Loading...</div>;
    }

    return (
        <StoreContext.Provider value={contextValue}>
            {children}
        </StoreContext.Provider>
    );
};

export const useStore = _function => {
    const [state, dispatch] = useContext(StoreContext);

    return [_function(state), dispatch];
};